import { GET_ALL_NOTIFICATIONS, MARK_NOTIFICATIONS_AS_READ, GET_ALL_UNREAD_NOTIFICATION_COUNT } from "../constants";

export const getAllNotificationsURL = () => GET_ALL_NOTIFICATIONS;
export const markAllNotificationsAsRead = () => MARK_NOTIFICATIONS_AS_READ;
export const markNotificationAsRead = (notificationId: number) => `${MARK_NOTIFICATIONS_AS_READ}${notificationId}`;
export const getAllUnreadNotificationsCount = () => GET_ALL_UNREAD_NOTIFICATION_COUNT;
export const getAllMagnetNotifications = (magnetId: string) =>
  `${GET_ALL_NOTIFICATIONS}?magnet_id=${magnetId}&page_size=100`;
